export default {
  app: '___DYNAMIC___', // TODO: fetch all resources from server
  api: '/portal'
};
